import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import { useUiUnitTypeValue } from './useUiStore';
import {
    ICountryActiveCardItem,
    ICountryInfo,
    ICountryOperatorItem,
    ICountryTelecomUsage,
    IUsageData,
} from '../../interfaces';
import { showOriginalUnitByType } from '../../instruments';

export function useCountryInfo(): ICountryInfo {
    return useContext(MobXProviderContext).RootStore.countryStore.info;
}
export function useCountryOperatorList(): ICountryOperatorItem[] {
    return useContext(MobXProviderContext).RootStore.countryStore.operatorsList;
}

export function useCountryActiveCardsList(): ICountryActiveCardItem[] {
    return useContext(MobXProviderContext).RootStore.countryStore.activeCardsList;
}

export function useCountryTelecomUsageTable(): ICountryTelecomUsage[] {
    const telecomUsageList = useContext(MobXProviderContext).RootStore.dashboardStore.telecomUsageList;
    const unitTypes = useUiUnitTypeValue();

    return telecomUsageList.map((item: IUsageData) => {
        const showUnit = showOriginalUnitByType(`${item.volume}`, unitTypes);
        return { name: item.name, usage: showUnit, id: item.operator_id };
    });
}
